import { useNavigate, useOutletContext } from "react-router-dom";

import ExperienceIndexResultsTab from "../_ExperienceIndexResultsTab";
import type { CareerProfileQueryResult } from "../_useCareerProfileQuery";
import { getExperienceIndexCompletion } from "../careerPlanHubSummaries";
import { careerProfileExperienceIndexAssessmentHref } from "../careerPlanLatest";

export default function CareerProfileExperienceIndexPage() {
  const navigate = useNavigate();
  const { pgaId, assessment, roleRubrics } = useOutletContext<CareerProfileQueryResult>();

  if (!pgaId) return null;

  const completion = getExperienceIndexCompletion(assessment);
  const assessmentComplete = completion.total > 0 && completion.remaining === 0;

  return (
    <ExperienceIndexResultsTab
      assessmentComplete={assessmentComplete}
      assessmentComparisonRole={assessment?.assessmentComparisonRole}
      scores={assessment?.scores ?? []}
      rubrics={roleRubrics}
      onSelectCompetency={(competencyId) => navigate(careerProfileExperienceIndexAssessmentHref(pgaId, competencyId))}
    />
  );
}
